

import {NgModule, Optional, SkipSelf} from '@angular/core';
import {ToastService} from "./toast.service";
import {ToastComponent} from "./toast.component";
import {CommonModule} from "@angular/common";
import {AppTranslateModule} from "../translate/translate.module";


@NgModule({
    imports: [
      CommonModule,
      AppTranslateModule
    ],
    exports: [
      ToastComponent
    ],
    declarations: [ToastComponent],
    providers: [ToastService],
})
export class ToastModule {
  constructor(@Optional() @SkipSelf() parentModule: ToastModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/toast/toast.module.ts